export default "__VITE_ASSET__Dp_hKtxD__"